import { Inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { WINDOW } from '@ng-web-apis/common';
import { OperatorFunction } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { SnackbarService } from '@fitscovery/ui/snackbar';
import { EventDownloadEventAttendeesResponse, UpdateEventAttendeeResponse } from '../models';

export class EventsControlState {

  constructor(
    @Inject(WINDOW) public window: any,
    public snackbar: SnackbarService
  ) { }

  get catchResponse(): OperatorFunction<any, any> {
    return catchError((response: HttpErrorResponse) => {
      const message = this.errorMessage(response);
      this.snackbar.openSnack({ message, duration: 5000 });
      throw new Error(message);
    });
  }

  get downloadCsvEventAttendeesResponse(): OperatorFunction<any, any> {
    return tap((response: EventDownloadEventAttendeesResponse) => {
      const downloadUrl = response.data.downloadUrl;
      this.window.open(downloadUrl);
    });
  }

  get updateEventAttendeeResponse(): OperatorFunction<any, any> {
    return tap((response: UpdateEventAttendeeResponse) => {
      const isPresent = response.request.isPresent;
      const message = isPresent ? 'Successfully confirmed attendee!' : 'Successfully cancelled attendee!';
      this.snackbar.openSnack({ message });
    });
  }

  get updateAllEventAttendeeResponse(): OperatorFunction<any, any> {
    return tap((response: UpdateEventAttendeeResponse) => {
      const isPresent = response.request.isPresent;
      const message = isPresent ? 'Successfully confirmed all attendees!' : 'Successfully cancelled all attendees!';
      this.snackbar.openSnack({ message });
    });
  }

  private errorMessage(response: HttpErrorResponse): string {
    const defaultErrorMessage = 'Sorry. An unexpected error occurred in Events. Kindly try again or if error persists, contact francis@fitscovery.com';
    return response.error?.errors[0] || defaultErrorMessage;
  }

}
